import * as Actions from './SessionQuestionsActions';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getSessionQuestions } from '../../Apis/ReportingReadApi';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';

export function* getSessionQuestionsWatcher() {
  yield takeLatest(Actions.GET_SESSION_QUESTIONS_REQUEST, getSessionQuestionsWorker);
}

export function* getSessionQuestionsWorker({ payload }) {
  const { sessionKey, pageNumber, size, filter } = payload;

  try {
    const { textSearch, answered, dateAskedSortOrder } = filter;

    const axiosResponse = yield call(
      getSessionQuestions,
      sessionKey,
      pageNumber,
      size,
      textSearch,
      answered,
      dateAskedSortOrder
    );
    const sessionQAndAs = axiosResponse.data._embedded ? axiosResponse.data._embedded.sessionQAndAs : [];
    const page = axiosResponse.data.page;
    yield put({
      type: Actions.GET_SESSION_QUESTIONS_SUCCESS,
      payload: { sessionQAndAs, page, filter }
    });
  } catch (error) {
    yield put({ type: Actions.GET_SESSION_QUESTIONS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getSessionQuestionsWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionQuestions/SessionQuestionsSagas.js